import mapsReducer from './maps.reducers'

export default mapsReducer
